import { useCallback, useEffect, useState } from 'react';

export interface UseOcInsightsSkipTimeoutsParams {
  imageTimeoutMs: number;
  materialPredictionTimeoutMs: number;
  isImageFetched: boolean;
  isMaterialPredictionPending: boolean;
  isMaterialPredictionFetched: boolean;
}

export interface UseOcInsightsSkipTimeoutsResult {
  isImageTimedOut: boolean;
  isMaterialPredictionTimedOut: boolean;
  reset: () => void;
}

export function useOcInsightsSkipTimeouts({
  imageTimeoutMs,
  materialPredictionTimeoutMs,
  isImageFetched,
  isMaterialPredictionPending,
  isMaterialPredictionFetched,
}: UseOcInsightsSkipTimeoutsParams): UseOcInsightsSkipTimeoutsResult {
  const [isImageTimedOut, setIsImageTimedOut] = useState(false);
  const [isMaterialPredictionTimedOut, setIsMaterialPredictionTimedOut] = useState(false);

  useEffect(() => {
    if (isImageFetched) return;
    const timer = setTimeout(() => setIsImageTimedOut(true), imageTimeoutMs);
    return () => clearTimeout(timer);
  }, [isImageFetched, imageTimeoutMs]);

  useEffect(() => {
    if (!isMaterialPredictionPending || isMaterialPredictionFetched || isMaterialPredictionTimedOut) return;
    const timer = setTimeout(() => setIsMaterialPredictionTimedOut(true), materialPredictionTimeoutMs);
    return () => clearTimeout(timer);
  }, [
    isMaterialPredictionPending,
    isMaterialPredictionFetched,
    isMaterialPredictionTimedOut,
    materialPredictionTimeoutMs,
  ]);

  const reset = useCallback(() => {
    setIsImageTimedOut(false);
    setIsMaterialPredictionTimedOut(false);
  }, []);

  return { isImageTimedOut, isMaterialPredictionTimedOut, reset };
}
